  import { createSlice } from "@reduxjs/toolkit";

  const login = createSlice({
    name: "login",
    initialState: {
      data: null,
      loading: false,
      error: null,
    },
    reducers: {
      loginRequest(state) {
        state.loading = true;
        state.error = null;
      },
      loginSuccess(state, action) {
        state.loading = false;
        state.data = action.payload;
      },
      loginFailure(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const { loginRequest, loginSuccess, loginFailure } = login.actions;
  export default login.reducer;
